export default "__VITE_ASSET__DagGnewI__"